const capSurveyStatusV2 = [
    { label: 'Vessel is less than 15 years old', value: 'Vessel is less than 15 years old' },
    { label: 'Vessel is less than 20 years old', value: 'Vessel is less than 20 years old' },
    { label: 'CAP not comply', value: 'CAP not comply' },
    { label: 'CAP Comply', value: 'CAP Comply' },
    { label: 'CAS not comply', value: 'CAS not comply' },
    { label: 'CAS Comply', value: 'CAS Comply' }
];

export default capSurveyStatusV2;
